import { ListItem, List, ListItemText, Paper, Typography } from "@mui/material";
import MoveUpButton from "./MoveUpButton";

export default function Privacy() {

    return(
        <Paper sx={{m: {xs: 1, sm: 4}, p: 4}}>
            <MoveUpButton/>
            <Typography variant="h1" color="th_color.main">Datenschutzerklärung</Typography>
            <Typography>
                Die Technische Hochschule OWL nimmt den Schutz personenbezogener Daten sehr ernst. Wir haben daher technische und 
                organisatorische Maßnahmen getroffen, die sicherstellen, dass die Vorschriften über den Datenschutz eingehalten werden. 
                Sämtliche Web-Aktivitäten erfolgen in Übereinstimmung mit den anwendbaren Rechtsvorschriften zum Schutz personenbezogener 
                Daten und zur Datensicherheit. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend 
                verbessert. Bei der Kommunikation per E-Mail kann die vollständige Datensicherheit von uns jedoch nicht gewährleistet werden, 
                so dass wir Ihnen bei der Übersendung von vertraulichen Informationen den Postweg empfehlen.

            </Typography>
            <br/>
            <Typography variant="h2" color="th_color.main">
                § 1 Information über die Erhebung personenbezogener Daten
            </Typography>
            <br/>
            <Typography>

                (1) Im Folgenden informieren wir über die Erhebung personenbezogener Daten bei Nutzung unserer Website. Personenbezogene Daten sind alle Daten, die auf Sie persönlich beziehbar sind, wie z. B. Name, Adresse, E-Mail-Adressen, Nutzerverhalten.
            </Typography>
            <br/>
            <Typography>
                (2) Verantwortliche gem. Art. 4 Abs. 7 EU-Datenschutz-Grundverordnung (DS-GVO) ist die Technische Hochschule OWL, Campusallee 12, D-32657 Lemgo. Unsere Datenschutzbeauftragte erreichen Sie unter unserer Postadresse mit dem Zusatz „die Datenschutzbeauftragte“ oder unter datenschutz(at)th-owl.de.
            </Typography>
            <br/>
            <Typography>
                (3) Bei Ihrer Kontaktaufnahme mit uns per E-Mail und/oder über das Kontaktformular werden die von Ihnen mitgeteilten Daten (Ihre E-Mail-Adresse, ggf. Ihr Name und Ihre Anfrage) von uns gespeichert, um Ihre Fragen zu beantworten. Die in diesem Zusammenhang anfallenden Daten löschen wir, nachdem die Speicherung nicht mehr erforderlich ist, oder schränken die Verarbeitung ein, falls gesetzliche Aufbewahrungspflichten bestehen. Rechtsgrundlage ist Art. 6 I (a) DSGVO in Verbindung mit dem Hochschulgesetz des Landes Nordrhein-Westfalen (HG NRW), da Sie bei der Anfrage per E-Mail an uns in die o.a. Verarbeitung Ihrer Daten einwilligen. Sie haben das Recht, die erteilte Einwilligung jederzeit zu widerrufen, ohne dass die Rechtmäßigkeit der aufgrund der Einwilligung erfolgten Verarbeitung berührt wird. Zum Anspruch auf Löschung und Auskunft, s. unten Ziffer 2 zu Ihren Betroffenenrechten.

            </Typography>
            <br/>
            <Typography variant="h2" color="th_color.main">
            § 2 Ihre Rechte
            </Typography>
            <br/>
            <Typography>
                (1) Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:
            </Typography>
            <br/>
            <List>
                <ListItem>
                    <ListItemText>
                    gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen. Insbesondere können Sie Auskunft über die Verarbeitungszwecke, die Kategorie der personenbezogenen Daten, die Kategorien von Empfängern, gegenüber denen Ihre Daten offengelegt wurden oder werden, die geplante Speicherdauer, das Bestehen eines Rechts auf Berichtigung, Löschung, Einschränkung der Verarbeitung oder Widerspruch, das Bestehen eines Beschwerderechts, die Herkunft Ihrer Daten, sofern diese nicht bei uns erhoben wurden, sowie über das Bestehen einer automatisierten Entscheidungsfindung einschließlich Profiling und ggf. aussagekräftigen Informationen zu deren Einzelheiten verlangen;
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                    gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder Vervollständigung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen;
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                    gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen, soweit nicht die Verarbeitung zur Ausübung des Rechts auf freie Meinungsäußerung und Information, zur Erfüllung einer rechtlichen Verpflichtung, aus Gründen des öffentlichen Interesses oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist;
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                    gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen, soweit die Richtigkeit der Daten von Ihnen bestritten wird, die Verarbeitung unrechtmäßig ist, Sie aber deren Löschung ablehnen und wir die Daten nicht mehr benötigen, Sie jedoch diese zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen benötigen oder Sie gemäß Art. 21 DSGVO Widerspruch gegen die Verarbeitung eingelegt haben;
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                    gemäß Art. 20 DSGVO Ihre personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten oder die Übermittlung an einen anderen Verantwortlichen zu verlangen;
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                    gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung jederzeit gegenüber uns zu widerrufen. Dies hat zur Folge, dass wir die Datenverarbeitung, die auf dieser Einwilligung beruhte, für die Zukunft nicht mehr fortführen dürfen
                    </ListItemText>
                </ListItem>
            </List>
            <Typography>
                (2) Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten Interessen gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO verarbeitet werden, haben Sie das Recht, gemäß Art. 21 DSGVO Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten einzulegen, soweit dafür Gründe vorliegen, die sich aus Ihrer besonderen Situation ergeben oder sich der Widerspruch gegen Direktwerbung richtet. Im letzteren Fall haben Sie ein generelles Widerspruchsrecht, das ohne Angabe einer besonderen Situation von uns umgesetzt wird.
            </Typography>
            <br/>
            <Typography>
                Richten Sie bitte Ihre Anfrage/Ihren Widerspruch an datenschutz(at)th-owl.de oder schriftlich an folgende Adresse:
            </Typography>
            <br/>
            <Typography sx={{fontWeight: "500"}}>
                Technische Hochschule OWL,
            </Typography>
            <Typography sx={{fontWeight: "500"}}>
                Campusallee 12,
            </Typography>
            <Typography sx={{fontWeight: "500"}}>
                D-32657 Lemgo.
            </Typography>
            <br/>
            <Typography>
                (3) Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren.
            </Typography>
            <br/>
            <Typography>
                Dies ist der:
            </Typography>
            <br/>
            <Typography sx={{fontWeight: "500"}}>
                Landesbeauftragte für Datenschutz und Informationsfreiheit
            </Typography>
            <Typography>
                Nordrhein-Westfalen
            </Typography>
            <Typography>
                Postfach 20 04
            </Typography>
            <Typography>
                40213 Düsseldorf
            </Typography>
            <Typography>
                Tel.: <a href="tel:+49 211 38424 0">+49 211 38424 0</a>
            </Typography>
            <Typography>
                Fax: <a href="tel:+49 211 38424 10">+49 211 38424 10</a>
            </Typography>
            <Typography>
                E-Mail: <a href="mailto:poststelle(at)ldi.nrw.de ">poststelle(at)ldi.nrw.de </a>
            </Typography>
            <br/>
            <Typography variant="h2" color="th_color.main">
                § 3 Erhebung personenbezogener Daten bei Besuch unserer Website            
            </Typography>
            <br/>
            <Typography>
                (1) Bei der bloß informatorischen Nutzung der Website, also wenn Sie sich nicht registrieren oder uns anderweitig Informationen übermitteln, erheben wir nur die personenbezogenen Daten, die Ihr Browser an unseren Server übermittelt. Wenn Sie unsere Website betrachten möchten, erheben wir die folgenden Daten, die für uns technisch erforderlich sind, um Ihnen unsere Website anzuzeigen und die Stabilität und Sicherheit zu gewährleisten (Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. f DSGVO):
            </Typography>
            <br/>
            <List>
                <ListItem>
                    <ListItemText>
                        pseudonymisierte IP-Adresse
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        Datum und Uhrzeit der Anfrage
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        Inhalt der Anforderung (konkrete Seite)
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                    Zugriffsstatus/HTTP-Statuscode
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                    jeweils übertragene Datenmenge
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                    Website, von der die Anforderung kommt
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                    Browser
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                    Betriebssystem und dessen Oberfläche
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                    Sprache und Version der Browsersoftware
                    </ListItemText>
                </ListItem>
            </List>
            <Typography>
                (2) Wir  setzen auf unserer Seite Cookies ein. Hierbei handelt es sich um kleine Dateien, die Ihr Browser automatisch erstellt und die auf Ihrem Endgerät (Laptop, Tablet, Smartphone o.ä.) gespeichert werden, wenn Sie unsere Seite besuchen. Cookies richten auf Ihrem Endgerät keinen Schaden an, enthalten keine Viren, Trojaner oder sonstige Schadsoftware.
                </Typography>
            <br/>
            <Typography>
                (3) In dem Cookie werden Informationen abgelegt, die sich jeweils im Zusammenhang mit dem spezifisch eingesetzten Endgerät ergeben. Dies bedeutet jedoch nicht, dass wir dadurch unmittelbar Kenntnis von Ihrer Identität erhalten. Der Einsatz von Cookies dient einerseits dazu, die Nutzung unseres Angebots für Sie angenehmer zu gestalten. So setzen wir sogenannte Session-Cookies ein, um zu erkennen, dass Sie einzelne Seiten unserer Website bereits besucht haben. Diese werden nach Verlassen unserer Seite automatisch gelöscht.
                </Typography>
            <br/>
            <Typography>
                (4) Darüber hinaus setzen wir ebenfalls zur Optimierung der Benutzerfreundlichkeit temporäre Cookies ein, die für einen bestimmten festgelegten Zeitraum auf Ihrem Endgerät gespeichert werden. Besuchen Sie unsere Seite erneut, um unsere Dienste in Anspruch zu nehmen, wird automatisch erkannt, dass Sie bereits bei uns waren und welche Eingaben und Einstellungen sie getätigt haben, um diese nicht noch einmal eingeben zu müssen.
                </Typography>
            <br/>
            <Typography>
                (5) Zum anderen setzen wir Cookies ein, um die Nutzung unserer Website statistisch zu erfassen und zum Zwecke der Optimierung unseres Angebotes für Sie auszuwerten (siehe Ziff. 4). Diese Cookies ermöglichen es uns, bei einem erneuten Besuch unserer Seite automatisch zu erkennen, dass Sie bereits bei uns waren. Diese Cookies werden nach einer jeweils definierten Zeit automatisch gelöscht.
                </Typography>
            <br/>
            <Typography>
                (6) Die durch Cookies verarbeiteten Daten sind für die genannten Zwecke zur Wahrung unserer berechtigten Interessen sowie der Dritter nach Art. 6 Abs. 1 S. 1 lit. f DSGVO erforderlich.
                </Typography>
            <br/>
            <Typography>
                (7) Die meisten Browser akzeptieren Cookies automatisch. Sie können Ihren Browser jedoch so konfigurieren, dass keine Cookies auf Ihrem Computer gespeichert werden oder stets ein Hinweis erscheint, bevor ein neuer Cookie angelegt wird. Die vollständige Deaktivierung von Cookies kann jedoch dazu führen, dass Sie nicht alle Funktionen unserer Website nutzen können.
                </Typography>
            <br/>
            <Typography variant="h2" color="th_color.main">
                § 4 YouTube
            </Typography>
            <br/>
            <Typography>
                Auf dieser Seite sind Videos von Drittanbietern über das Videoportal „YouTube“ der YouTube LLC mit Hauptgeschäftssitz in 901 Cherry Avenue, San Bruno, CA 94066, USA als Inhalte eingebunden. Durch Anklicken eines Videos und die damit verbundene Nutzung von YouTube können Ihre Daten durch „YouTube“ verarbeitet werden. Wenn Sie bei Abruf des Videos gleichzeitig mit Ihrem Benutzerkonto bei „Google/YouTube“ angemeldet sind, kann YouTube nachvollziehen, von welcher Unterseite unseres Internetauftritts das Video abgerufen wird. Möchten Sie diese Datenerhebung verhindern, loggen Sie sich bitte vor dem Besuch unserer Seite bzw. dem Abruf des Videos bei YouTube aus. Einzelheiten können Sie den Nutzungsbedingungen von „YouTube“ sowie, da „YouTube“ ein „Google“-Unternehmen ist, den Datenschutzrichtlinien von „Google“ entnehmen.
            </Typography>
            <br/>
            <Typography>
                Rechtsgrundlage ist Art. 6 I (f) DSGVO. Unser berechtigtes Interesse ergibt sich daraus, dass wir Ihnen mit Einbettung der Videos einen informativen Mehrwert über unsere Tätigkeit bzw. über für Sie fachlich interessante Informationen bieten. Unsererseits werden dabei keine Daten von Ihnen gespeichert. Wenn Sie die Datenerhebung durch Google vollständig verhindern möchten, sollten Sie von einem Abruf der Videos absehen. Durch die Einbettung und Abrufbarkeit der Videos findet kein Eingriff in Ihre Grundfreiheiten statt.
            </Typography>
            <br/>
            <Typography variant="h2" color="th_color.main">
                § 5 Nutzung Social Media (Facebook, Twitter, Instagram)
            </Typography>
            <br/>
            <Typography>
                Die Online-Präsenz der Technischen Hochschule OWL verwendet keine direkten Einbindungen von Social Media Plugins (z.B Like-Buttons) der sozialen Netzwerke Facebook, Twitter oder Instagram. Somit werden beim Aufruf der Webseiten keine Daten an externe soziale Netzwerke übermittelt. Erst wenn Sie Icons/Symbole/Links der sozialen Netzwerke auf den Webseiten der Technischen Hochschule anklicken und die darüber verlinkten Seiten aufrufen, verlassen Sie die Webseiten, die sich in der Verantwortung der Technischen Hochschule OWL befinden, und es erfolgen Aufrufe externer Webseiten entsprechend den Bedingungen des jeweiligen Anbieters / sozialen Netzwerks.
                </Typography>
            <br/>
            <Typography>
                Wir weisen darauf hin, dass dabei Daten der Nutzer außerhalb des Raumes der Europäischen Union verarbeitet werden können. Hierdurch können sich für die Nutzer Risiken ergeben, weil so z.B. die Durchsetzung der Rechte der Nutzer erschwert werden könnte.
                </Typography>
            <br/>
            <Typography>
                Für eine detaillierte Darstellung der jeweiligen Verarbeitungen und der Widerspruchsmöglichkeiten (Opt-Out) verweisen wir auf die nachfolgend verlinkten Angaben der Anbieter.
            </Typography>
            <br/>
            <Typography>
                Auch im Fall von Auskunftsanfragen und der Geltendmachung von Nutzerrechten, weisen wir darauf hin, dass diese am effektivsten bei den Anbietern geltend gemacht werden können. Nur die Anbieter haben jeweils Zugriff auf die Daten der Nutzer und können direkt entsprechende Maßnahmen ergreifen und Auskünfte geben. Sollten Sie dennoch Hilfe benötigen, dann können Sie sich an uns wenden.
            </Typography>
            <br/>
            <List>
                <ListItem>
                    <ListItemText sx={{wordWrap: "break-word"}}>
                    Facebook (Facebook Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland), Facebook-Seiten auf <a href="https://www.facebook.com/legal/terms/page_controller_addendum">Grundlage einer Vereinbarung über gemeinsame Verarbeitung personenbezogener Daten</a> – Datenschutzerklärung: <a href="https://www.facebook.com/about/privacy/">https://www.facebook.com/about/privacy/</a>, Opt-Out: <a href="https://www.facebook.com/settings?tab=ads">https://www.facebook.com/settings?tab=ads</a> und <a href="http://www.youronlinechoices.com">http://www.youronlinechoices.com</a>,
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText sx={{wordWrap: "break-word"}}>
                    Google/ YouTube (Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland) – Datenschutzerklärung:  <a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>, Opt-Out: <a href="https://adssettings.google.com/authenticated">https://adssettings.google.com/authenticated</a>,
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText sx={{wordWrap: "break-word"}}>
                    Instagram (Instagram Inc., 1601 Willow Road, Menlo Park, CA, 94025, USA) – Datenschutzerklärung/ Opt-Out: <a href="http://instagram.com/about/legal/privacy/">http://instagram.com/about/legal/privacy/</a>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText sx={{wordWrap: "break-word"}}>
                    Twitter (Twitter Inc., 1355 Market Street, Suite 900, San Francisco, CA 94103, USA) – Datenschutzerklärung: <a href="https://twitter.com/de/privacy">https://twitter.com/de/privacy</a>, Opt-Out: <a href="https://twitter.com/personalization">https://twitter.com/personalization</a>,
                    </ListItemText>
                </ListItem>
            </List>   
            <br/>
            <Typography variant="h2" color="th_color.main">
                § 6 Weitere Funktionen und Angebote unserer Website
            </Typography>
            <br/>
            <Typography>
                (1) Personenbezogene Daten, die im Rahmen der Nutzung der Webseite der Technischen Hochschule OWL verarbeitet werden, geben wir grundsätzlich nicht an Dritte weiter.
            </Typography>
            <br/>
            <Typography>
                (2) In Einzelfällen bedienen wir uns zur Verarbeitung Ihrer Daten externer Dienstleister. Diese wurden von uns sorgfältig ausgewählt und beauftragt, sind an unsere Weisungen gebunden und werden regelmäßig kontrolliert, dies geschieht auf Grundlage eines Vertrags gemäß Art. 28 DSGVO.
            </Typography>
            <br/>
            <Typography>
                (3) Weiterhin können wir Ihre personenbezogenen Daten an Dritte weitergeben, wenn dies zur Durchführung des Bildungsauftrags, zur Durchsetzung unserer Rechte im Rahmen der Regelungen der Strafprozessordnung (StPO) oder zwecks Geltendmachung von Schadensersatzansprüchen bei Urheberrechtsverletzungen und Aufklärung von Straftaten sowie zur Beratung und Betreuung unserer Studierenden erforderlich ist.
            </Typography>
            <br/>
            <Typography variant="h2" color="th_color.main">
                § 7 Datensicherheit
            </Typography>
            <br/>
            <Typography>
                Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird. In der Regel handelt es sich dabei um eine 256 Bit-Verschlüsselung. Falls Ihr Browser keine 256 Bit-Verschlüsselung unterstützt, greifen wir stattdessen auf 128 Bit-v3-Technologie zurück. Ob eine einzelne Seite unseres Internetauftrittes verschlüsselt übertragen wird, erkennen Sie an der geschlossenen Darstellung des Schüssel- beziehungsweise Schloss-Symbols in der unteren Statusleiste Ihres Browsers.
            </Typography>
            <br/>
            <Typography>
                Wir bedienen uns im Übrigen geeigneter technischer und organisatorischer Sicherheitsmaßnahmen, um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, teilweisen oder vollständigen Verlust, Zerstörung oder gegen den unbefugten Zugriff Dritter zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert.
            </Typography>
            <br/>
            <Typography variant="h2" color="th_color.main">
                § 8 Änderung der Datenschutzerklärung
            </Typography>
            <br/>
            <Typography>
                Wir behalten es uns vor, diese Datenschutzerklärung von Zeit zu Zeit zu aktualisieren, insbesondere um die sich ändernde Gesetzgebung oder Rechtsprechung einfließen zu lassen. Wir empfehlen Ihnen daher, diese Website regelmäßig zu besuchen, damit Sie über den Schutz und die Verarbeitung Ihrer Daten informiert sind.
            </Typography>
        </Paper>
    )
}